import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterText',
})
export class FilterTextPipe implements PipeTransform {
	transform(items: any[], searchText: string): any[] {
		if (!items) return [];
		if (!searchText) return items;

		const LOWER_CASE_TEXT = searchText?.toLowerCase();

		return items.filter((item) => {
			if (typeof item === 'string') {
				// Handle the case where item is a string
				return item.toLowerCase().includes(LOWER_CASE_TEXT);
			} else if (typeof item === 'number') {
				// Handle the case where item is a number
				return item.toString().toLowerCase().includes(LOWER_CASE_TEXT);
			} else if (item.name) {
				// Handle the case where item is an object with a 'name' property
				return item.name.toLowerCase().includes(LOWER_CASE_TEXT);
			}
			// Handle other cases where neither condition is met
			return false;
		});
	}
}
